
export const ROUTES = {
  LandingPage: '/straygames',
  HOME: '/home',
  Services: '/Services',
  APPS: '/apps',
  APPS_AEC: '/apps/aec-tools',
  APPS_CUSTOM: '/apps/custom-tools',
  APPS_CONSULTING: '/apps/consulting',
  RESOURCES: '/resources',
  RESOURCES_ARTICLES: '/resources/articles',
  RESOURCES_CASE_STUDIES: '/resources/case-studies',
  RESOURCES_INDUSTRY_SOLUTIONS: '/resources/industry-solutions',
  RESOURCES_DETAIL: '/resources/:slug',
  Playground: '/Playground',
  About: '/',
  CONTACT: '/contact',
  LOGIN: '/login',
  REGISTER: '/register',
  STREAM: '/stream/:gameId',
  PROFILE: '/profile',
  SUCCESS: '/success',
  CANCEL: '/cancel',
  //POCs
  GAME_LIBRARY: '/library',
  LIBRARY_CUSTOM: '/library/custom',
  LIBRARY_AEC: '/library/aec',
  LIBRARY_AEC_COMPARE: '/library/aec/compare',
  LIBRARY_AEC_COMPARE_SLUGS: '/library/aec/compare/:slugs',
  LIBRARY_AEC_TOOL: '/library/aec/:slug',
  CONSULTING: '/consulting',
  // Industry Solutions
  FINTECH: '/industry-solutions/fintech',
  CONSTRUCTION_TECH: '/industry-solutions/construction-tech',
  CREATIVE_INDUSTRIES: '/industry-solutions/creative-industries',
  // Case Studies
  CASESTUDY1: '/case-studies/casestudy1',
  CASESTUDY2: '/case-studies/casestudy2',
  // InviteApp
  INVITEAPP_HOME: '/Playground/Inviteapp',
  INVITEAPP_TEMPLATES: '/Playground/Inviteapp/templates',
  INVITEAPP_CREATE: '/Playground/Inviteapp/create/:templateId',
  INVITEAPP_PREVIEW: '/Playground/Inviteapp/preview',
  INVITEAPP_SEND: '/Playground/Inviteapp/send',
  INVITEAPP_VIEW: '/Playground/Inviteapp/invite/:shortId',
};

export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.INVITEAPP_VIEW];